import thunk from "redux-thunk";
import { applyMiddleware, createStore, compose } from "redux";
import { reducers } from "./reducers";
import { getUserFromSessionStorage } from "./utils";
import { TypedUseSelectorHook, useSelector } from "react-redux";

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  { user: getUserFromSessionStorage() },
  composeEnhancers(applyMiddleware(thunk))
);

const hotModule = module as NodeModule & {
  hot?: { accept: (dependency: string, callback: () => void) => void };
};

if (process.env.NODE_ENV !== "production" && hotModule.hot) {
  hotModule.hot.accept("./reducers", () => store.replaceReducer(reducers));
}

export { store };
export * from "./actions";
export * from "./types";
export * from "./utils";
export type State = ReturnType<typeof reducers>;

export const useTypedSelector: TypedUseSelectorHook<State> = useSelector;
